'use strict';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import wrapWords from '../../../src/js/shared/wrapWords';

const $ = jQuery.noConflict();
$(function() {

	const imageText = {

		init: function() {
			this.cacheDOM();
			if (!this.section) {
				return;
			}
			if (this.prefersReducedMotion()) {
				return;
			}
			gsap.registerPlugin(ScrollTrigger);
			ScrollTrigger.config({ignoreMobileResize: true});
			this.wrapDescriptionWords();
			this.animateDescription();
			this.animateRows();
		},

		cacheDOM: function() {
			this.section = document.querySelector('.js-image-text');
			if (!this.section) {
				return;
			}
			this.description = this.section.querySelector('.js-image-text-description');
			this.rows = this.section.querySelectorAll('.js-image-text-row');
		},

		prefersReducedMotion: function() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

		wrapDescriptionWords: function() {
			if (!this.description) {
				return;
			}
			wrapWords.wrap([this.description], 'image-text__description-word', 'js-image-text-word');
		},

		animateDescription: function() {
			if (!this.description) {
				return;
			}
			const words = this.description.querySelectorAll('.js-image-text-word');
			if (!words.length) {
				return;
			}
			gsap.set(words, {opacity: 0.12});
			gsap.to(words, {
				opacity: 1,
				ease: 'none',
				stagger: {amount: 0.8, from: 'start'},
				scrollTrigger: {
					trigger: this.description,
					start: 'top 70%',
					end: 'bottom 65%',
					scrub: 1,
					invalidateOnRefresh: true,
				},
			});
		},

		animateRows: function() {
			if (!this.rows.length) {
				return;
			}
			this.rows.forEach((row) => {
				const media = row.querySelector('.image-text__media');
				const body = row.querySelector('.image-text__body');
				const isReversed = row.classList.contains('image-text__row--reversed');

				const isMobile = window.innerWidth <= 767;
				const mediaX = isMobile ? 0 : (isReversed ? 40 : -40); // eslint-disable-line no-nested-ternary
				const bodyX = isMobile ? 0 : (isReversed ? -40 : 40); // eslint-disable-line no-nested-ternary

				if (media) {
					gsap.fromTo(
						media,
						{opacity: 0, x: mediaX},
						{
							opacity: 1,
							x: 0,
							duration: 0.9,
							ease: 'power2.out',
							scrollTrigger: {
								trigger: row,
								start: 'top 70%',
								toggleActions: 'play none none none',
								invalidateOnRefresh: true,
							},
						}
					);
				}

				if (body) {
					gsap.fromTo(
						body,
						{opacity: 0, x: bodyX},
						{
							opacity: 1,
							x: 0,
							duration: 0.9,
							delay: 0.15,
							ease: 'power2.out',
							scrollTrigger: {
								trigger: row,
								start: 'top 70%',
								toggleActions: 'play none none none',
								invalidateOnRefresh: true,
							},
						}
					);
				}
			});
		},

	};

	imageText.init();
});
